import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { IFavouriteTransfersService } from '../entities/IFavouriteTransfersService';
import { IFavouriteTransfersRepository } from '../entities/IFavouriteTransfersRepository';
import { FavouriteTransfer, NewFavouriteAppTransactionRequestDTO } from '../entities';
import { NewFavouriteTransferBody } from '../entities/NewFavouriteTransferResponseDTO';
import { NewFavouriteAppTransactionBody } from '../entities/NewFavouriteAppTransactionResponseDTO';
import { DeleteFavouriteTransferResponseBody } from '../entities/DeleteFavouriteTransferResponseDTO';
import { EditFavouriteTransferResponseBody } from '../entities/EditFavouriteTransferResponseDTO';
import { FavouriteTransfersList } from '../entities/FavouriteTransfersListResponseDTO';
import { FavouriteTransferDTODataType } from '../types';

export class FavouriteTransfersServiceImpl implements IFavouriteTransfersService {
  itemRepo: IFavouriteTransfersRepository;

  constructor(ir: IFavouriteTransfersRepository) {
    this.itemRepo = ir;

    this.GetFavouriteTransfers = this.GetFavouriteTransfers.bind(this);
    this.CreateNewFavouriteTransfer = this.CreateNewFavouriteTransfer.bind(this);
    this.CreateNewFavouriteAppTransaction = this.CreateNewFavouriteAppTransaction.bind(this);
    this.DeleteFavouriteTransfer = this.DeleteFavouriteTransfer.bind(this);
    this.EditFavouriteTransfer = this.EditFavouriteTransfer.bind(this);
    this.GetFavouriteTransfer = this.GetFavouriteTransfer.bind(this);
  }

  GetFavouriteTransfers(params: {
    customerId: number;
    pageSize: number;
    pageOffset: number;
    name?: string;
    debitAccountNumber?: string;
    creditAccountNumber?: string;
    amountFrom?: number;
    amountTo?: number;
    currency?: string;
  }): Promise<FavouriteTransfersList> {
    return this.itemRepo.GetFavouriteTransfers(
      params.customerId,
      params.pageSize,
      params.pageOffset,
      params.name,
      params.debitAccountNumber,
      params.creditAccountNumber,
      params.amountFrom,
      params.amountTo,
      params.currency,
    );
  }

  CreateNewFavouriteTransfer(params: {
    appTransactionUniqueId: number;
    name: string;
    customerId: string;
    shared: boolean;
    successCallback?: SuccessCallback;
    errorCallback?: ErrorCallback;
  }): Promise<NewFavouriteTransferBody> {
    return this.itemRepo.CreateNewFavouriteTransfer(
      params.appTransactionUniqueId,
      params.name,
      params.customerId,
      params.shared,
      params?.successCallback,
      params?.errorCallback,
    );
  }

  CreateNewFavouriteAppTransaction(params: {
    data: NewFavouriteAppTransactionRequestDTO;
  }): Promise<NewFavouriteAppTransactionBody> {
    return this.itemRepo.CreateNewFavouriteAppTransaction(params.data);
  }

  DeleteFavouriteTransfer(params: {
    customerId: number;
    id: number;
    successCallback?: SuccessCallback;
  }): Promise<DeleteFavouriteTransferResponseBody> {
    return this.itemRepo.DeleteFavouriteTransfer(params.customerId, params.id, params.successCallback);
  }

  EditFavouriteTransfer(params: {
    customerId: number;
    id: number;
    name: string;
    shared: boolean;
    data: FavouriteTransferDTODataType;
    successCallback?: SuccessCallback;
  }): Promise<EditFavouriteTransferResponseBody> {
    return this.itemRepo.EditFavouriteTransfer(
      params.customerId,
      params.id,
      params.name,
      params.shared,
      params.data,
      params?.successCallback,
    );
  }

  GetFavouriteTransfer(params: { customerId: number; id: number }): Promise<FavouriteTransfer> {
    return this.itemRepo.GetFavouriteTransfer(params.customerId, params.id);
  }
}
